const axios = require('axios');

export default {
  postRegister: async (data) => axios.post('/api/register', data)
}